import { createSlice } from '@reduxjs/toolkit';

const initialState = new Date().getFullYear();

const cursoYearFilterSlice = createSlice({
	name: 'cursoYearFilterState',
	initialState,
	reducers: {
		setCursoFilterYear: (state, action) => {
			return action.payload;
		}
	}
});

export const { setCursoFilterYear } = cursoYearFilterSlice.actions;

export default cursoYearFilterSlice.reducer;
